import React, { Fragment, useEffect, useState } from "react";
import Cookies from "universal-cookie";
import Consolidado from "./Consolidado";

const cookie = new Cookies();

let urlendpoint = "";
const tipoUsuario = cookie.get("tipo_Usuario");
const correo = cookie.get("correo");
const id = cookie.get("id");

if (tipoUsuario == 1) {
  urlendpoint =
    "https://educacionapi.azurewebsites.net/api/ObtenerPorRegional?regional=" +
    correo +
    "&Estado=Cerrados";
} else if (tipoUsuario == 2) {
  urlendpoint =
    "https://educacionapi.azurewebsites.net/api/ObtenerPorRegional?regional=" +
    correo +
    "&Estado=Cerrados";
} else if (tipoUsuario == 3) {
  urlendpoint =
    "https://educacionapi.azurewebsites.net/api/ObtenerPorUsuario?idusuario=" +
    id +
    "&estado=Cerrados";
}

function SolicitudesApRch() {
  const [solici, setSoli] = useState([]);
  const [search, setSearch] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;

  const showData = async () => {
    const response = await fetch(urlendpoint);
    const data = await response.json();
    setSoli(data);
  };

  useEffect(() => {
    showData();
  }, []);

  const searcher = (e) => {
    setSearch(e.target.value);
    setCurrentPage(1); // Reiniciar a la primera página al buscar
  };

  const results = !search
    ? solici
    : solici.filter((dato) =>
        dato.nombreCliente?.toLowerCase().includes(search.toLowerCase())
      );

  // Paginar resultados
  const totalPages = Math.ceil(results.length / itemsPerPage);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = results.slice(indexOfFirstItem, indexOfLastItem);

  return (
    <Fragment>
      <div className="container">
        <div className="text-center">
          <div className="container-fluid">
            <div className="card shadow mb-12">
              <div className="card-header py-12">
                <h6 className="m-0 font-weight-bold text-primary">
                  Solicitudes Aprobadas/Rechazadas
                </h6>
                <hr />
              </div>
              <div className="card-body">
                <input
                  value={search}
                  onChange={searcher}
                  type="text"
                  placeholder="Buscar por nombre del cliente"
                  className="form-control mb-3"
                />

                <table
                  className="table table-bordered"
                  id="dataTable"
                  width="100%"
                  cellSpacing="0"
                >
                  <thead>
                    <tr>
                      <th>Id</th>
                      <th>Nombre cliente</th>
                      <th>Correo Gestor</th>
                      <th>Estado</th>
                      <th>Detalle Estado</th>
                      <th>Fecha Creación</th>
                      <th>Consultar</th>
                    </tr>
                  </thead>
                  <tbody>
                    {currentItems.length === 0 ? (
                      <tr>
                        <td colSpan="7" className="text-center text-muted">
                          No hay resultados
                        </td>
                      </tr>
                    ) : (
                      currentItems.map((item) => {
                        const fecha = new Date(item.fechaCreacion);
                        return (
                          <tr key={item.id}>
                            <td>{item.id}</td>
                            <td>{item.nombreCliente}</td>
                            <td>{item.regional}</td>
                            <td>{item.estado}</td>
                            <td>{item.detalleEstado}</td>
                            <td>{fecha.toLocaleDateString("en-US")}</td>
                            <td>
                              <Consolidado
                                id={item.id}
                                regional={item.regional}
                                descripcion={item.descripcion}
                                estado={item.estado}
                                fechaCreacion={item.fechaCreacion}
                                nombreCliente={item.nombreCliente}
                                adjunto1={item.adjunto}
                                adjunto2={item.adjunto2}
                                usuarioId={item.usuarioId}
                                userIdAsignacion={item.userIdAsignacion}
                                clasificacionComercial={
                                  item.clasificacionComercial
                                }
                                modalidad={item.modalidad}
                                modular={item.modular}
                                nombreCapacitacion={item.nombreCapacitacion}
                                duracion={item.duracion}
                                numeroParticipantes={item.numeroParticipantes}
                                entregables={item.entregables}
                                otrosRequerimientos={item.otrosRequerimientos}
                                campoObservacion={item.campoObservacion}
                                regionalAsignado={item.regionalAsignado}
                                usuarioAsignado={item.nombreUsuario}
                                detalleEstado={item.detalleEstado}
                                correoCreador={item.correoCreador}
                              />
                            </td>
                          </tr>
                        );
                      })
                    )}
                  </tbody>
                </table>

                {/* Paginador */}
                {results.length > itemsPerPage && (
                  <div className="d-flex justify-content-between align-items-center mt-3">
                    <button
                      className="btn btn-outline-primary"
                      onClick={() =>
                        setCurrentPage((prev) => Math.max(prev - 1, 1))
                      }
                      disabled={currentPage === 1}
                    >
                      ← Anterior
                    </button>
                    <span>
                      Página {currentPage} de {totalPages}
                    </span>
                    <button
                      className="btn btn-outline-primary"
                      onClick={() =>
                        setCurrentPage((prev) => Math.min(prev + 1, totalPages))
                      }
                      disabled={currentPage === totalPages}
                    >
                      Siguiente →
                    </button>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
}

export default SolicitudesApRch;
